// extracted by mini-css-extract-plugin
module.exports = {"BreadCrumb":"BreadCrumbs_BreadCrumb__yRJC_"};